__webpack_require__.p = "/sidebar-menu-marketplace-fix/referrals-hub/";